module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_speech-bubble-ab4aba747d23f51f0e06fef2a179f73b.svg";